import { render } from "./WizardWrap.vue?vue&type=template&id=7a4781c7"
import script from "./WizardWrap.vue?vue&type=script&lang=js"
export * from "./WizardWrap.vue?vue&type=script&lang=js"

import "./WizardWrap.vue?vue&type=style&index=0&id=7a4781c7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__